import { capitalize } from 'lodash';

/**
 * Formats a display name by converting the first letter of each word to uppercase and the other letters to lowercase.
 * @param {string} displayName - The display name to format.
 * @returns {string} The formatted display name.
 */
export const format = (displayName: string) =>
    !displayName ? '' : displayName.split(/\s+/).map(capitalize).join(' ').trim();
